import React from 'react';
import styles from './index.scss';

const AppStatus = ({ status }) => <div className={[styles.status, styles[status]].join(' ')}>{status}</div>;

export default AppStatus;
